// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__26PNZ","header":"ClearentDisclaimer_header__3xkds","inner":"ClearentDisclaimer_inner__2QeH5"};